// Whose system it is, on screen (STAGE_7 7.7): the tab title, the favicon and the
// interface's main colour come from the product's settings (the vendor's) and the
// organization's name, as GET /config gives them - nothing is written into the build.

import { ConfigProvider } from 'antd';
import { useEffect, type ReactNode } from 'react';

import { fileUrl } from '@/api/client';

import { useAppConfig } from './configContext';
import { tabTitle } from './tabTitle';

export function ProductBranding({ children }: { children: ReactNode }) {
  const config = useAppConfig();
  const { product_name: product, org_name: org, product_icon: icon, product_color: color } =
    config;

  useEffect(() => {
    document.title = tabTitle(product, org);
  }, [product, org]);

  useEffect(() => {
    if (!icon) return;
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = fileUrl(icon);
  }, [icon]);

  // Nested: the light and dark themes stay the parent's, only the main colour changes.
  return <ConfigProvider theme={{ token: { colorPrimary: color } }}>{children}</ConfigProvider>;
}
